import { Tag as ChakraTag } from '@chakra-ui/react';

type TagProps = React.ComponentProps<typeof ChakraTag>;

const Tag = ({ children, ...props }: Readonly<TagProps>) => {
  return <ChakraTag {...props}>{children}</ChakraTag>;
};

export default Tag;
